/* eslint-disable jsx-a11y/aria-activedescendant-has-tabindex */
/* for some reason that rule wants that div to be tappable, but that's not by the w3c spec */

import React from 'react'
import { injectIntl } from 'sb-react-intl'
import { useCallback } from 'sb-hooks'

import messages from './messages'


interface InputWrapperProps {
  id: string
  inputId: string
  controlsId: string
  activeDescendantId: string
  className?: string
  label: string
  children: React.ReactElement
  isOpen: boolean

  setIsOpen(value: boolean): void

  // TODO: refactor injectIntl to TS and declare types
  // @injectIntl
  intl: Intl,
}

const InputWrapper: React.FunctionComponent<InputWrapperProps> = (props) => {
  let {
    intl,
    className, label, children, isOpen, setIsOpen,
    id, inputId, controlsId, activeDescendantId,
  } = props

  if (!label) {
    label = intl.formatMessage(messages.label)
  }

  const handleFocus = useCallback(() => {
    setIsOpen(true)
  }, [ setIsOpen ])

  return (
    <div
      id={id}
      className={className}
      aria-haspopup="listbox"
      aria-expanded={isOpen ? 'true' : 'false'}
      role="combobox"
      aria-controls={controlsId}
      aria-activedescendant={activeDescendantId}
      aria-label={label}
      onFocus={handleFocus}
      tabIndex={-1}
    >
      {
        React.cloneElement(children, { id: inputId })
      }
    </div>
  )
}


export default injectIntl(InputWrapper)
